import { render, staticRenderFns } from "./ContainerHosts.vue?vue&type=template&id=53995895&"
import script from "./ContainerHosts.vue?vue&type=script&lang=js&"
export * from "./ContainerHosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports